import {useTranslation} from 'hooks/translations/useCustomTranslation';
import Head from 'next/head';

// import Image from 'next/image';
import {Container} from '@mui/material';

import {DefaultPagePropsProvider, TDefaultProps} from 'utils/dataFetching/DefaultPagePropsProvider';

import {Box, Button, Grid} from 'components/basic-components';

// import ErrorImage from 'components/error/assets/error.png';
// import styles from 'components/error/errorPage.module.scss';

// import DefaultWrapper from 'components/layout/DefaultWrapper';
// import MainLayout from 'components/layout/MainLayout/MainLayout';

// 1. Create a Type for the HoC Props
type WithErrorProps = {
  hasError: boolean;
  defaultProps: TDefaultProps;
};

// 2. Define the HoC
export function withPageErrorComponent<P extends object>(
  WrappedComponent: any,
  CustomErrorComponent?: React.ComponentType<{defaultProps: TDefaultProps}>,
): React.FC<P & WithErrorProps> {
  return function PageWithError({hasError, ...props}: WithErrorProps & P) {
    if (hasError) {
      const {defaultProps} = props;
      if (CustomErrorComponent) {
        return <CustomErrorComponent defaultProps={defaultProps} />;
      }
      // Handle the error or display an error component.
      return <ErrorComponent defaultProps={defaultProps} />;
    }

    return <WrappedComponent {...(props as P)} />;
  };
}

const ErrorComponent = ({defaultProps}) => {
  const {t} = useTranslation('common');

  return (
    <DefaultPagePropsProvider defaultProps={defaultProps}>
      {/* <MainLayout translatedSlugs={[{slug: '', locale: 'de'}]}> */}
      <Head>
        <title>{t('error')}</title>
      </Head>
      <Container
        //  className={styles.containerImage}
        maxWidth={false}
        disableGutters
      >
        <Box
        //  className={styles.container}
        >
          <Box
          //  className={styles.errorImageContainer}
          >
            {/* <Image
              alt=""
              src={ErrorImage}
              className={styles.errorImage}
              objectPosition={'center'}
            ></Image> */}
          </Box>
        </Box>
      </Container>
      <Container
        // className={styles.containerAction}
        maxWidth={false}
        disableGutters
      >
        <Grid container justifyContent={'center'} spacing={0}>
          <Button
            // className={styles.retryButton}
            type="button"
            size={'small'}
            onClick={() => {
              window.location.reload();
            }}
          >
            {t('tryAgain')}
          </Button>
        </Grid>
      </Container>
      {/* </MainLayout> */}
    </DefaultPagePropsProvider>
  );
};
